import { ReactNode } from 'react';
import { BannerWrapper } from './styles';

interface BannerProps {
  title: string;
  children: ReactNode;
}

export function Banner({ title, children }: Readonly<BannerProps>) {
  return (
    <BannerWrapper>
      <header>{title}</header>
      <main>{children}</main>
    </BannerWrapper>
  );
}
